module.exports = __webpack_public_path__ + "static/media/ALAA ALLTFO .a987a9ce.png";